export default {
  "backward-and-navbar": () => import("/root/code-vivasport/vs2-front/layouts/backwardAndNavbar.vue").then(m => m.default || m),
  "backward-auth": () => import("/root/code-vivasport/vs2-front/layouts/backwardAuth.vue").then(m => m.default || m),
  navbar: () => import("/root/code-vivasport/vs2-front/layouts/navbar.vue").then(m => m.default || m)
}